import { render, staticRenderFns } from "./AsideMessageComponent.vue?vue&type=template&id=c494d1b0"
import script from "./AsideMessageComponent.vue?vue&type=script&lang=js"
export * from "./AsideMessageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports